/* eslint-disable no-magic-numbers */
export default class CzVatRates {
  static NEW_RATES_START_DATE = "2024-01-01";

  static OLD = [21, 15, 10, 0];

  static NEW = [21, 12, 0];
}
